import { useSmartContextLinkRecommendations as useStoredSmartContextLinkRecommendations } from '../../controllers/space-store/hooks';
import type { SmartContextLinkRecommendation } from '../../controllers/space-store/types';

export type UseSmartContextLinkRecommendationsResult = {
	/** Recommended links for the given space. */
	recommendations: SmartContextLinkRecommendation[];
	/** Convenience accessor — equals `recommendations.length`. */
	count: number;
	/**
	 * `true` while the recommendations are being fetched or resolved.
	 * TODO(ROVOFE-3051): stubbed to `false` — recommendations are pushed on the
	 * chat stream, so there is no load phase yet. Wire this up if a fetch-based
	 * source is added.
	 */
	isLoading: boolean;
	/**
	 * Populated when the recommendation source fails.
	 * TODO(ROVOFE-3051): stubbed to `null` — the push-based source surfaces
	 * errors on the chat stream, not here.
	 */
	error: Error | null;
};

export type UseSmartContextLinkRecommendationsOptions = {
	/** Space the recommendations are scoped to. */
	spaceId: string;
};

export const useSmartContextLinkRecommendations = (
	options: UseSmartContextLinkRecommendationsOptions,
): UseSmartContextLinkRecommendationsResult => {
	const recommendations = useStoredSmartContextLinkRecommendations(options.spaceId);

	return {
		recommendations,
		count: recommendations.length,
		isLoading: false,
		error: null,
	};
};
